import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 21898,
  clicks: 369,
  adsSpendDollars: 2170,
  budgetDollars: 14500,
  salesDollars: 4883,
  bestEstimateRoas: 2.25,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.15,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
